import { Component, Input, ContentChildren, QueryList, AfterContentInit, ChangeDetectorRef } from '@angular/core';
import { SidebarNavSectionLinkComponent } from './sidebar-nav-section-link.component';

@Component({
  selector: 'app-sidebar-nav-section',
  template: '<ng-content></ng-content>',
  styles: [':host { display: none; }']
})
export class SidebarNavSectionComponent implements AfterContentInit {
  @Input() label = '';
  @Input() logoClass = '';

  @ContentChildren(SidebarNavSectionLinkComponent) links!: QueryList<SidebarNavSectionLinkComponent>;

  isExpanded = false;
  isSlim = false;

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    // Watch for changes in child components
    this.links.changes.subscribe(() => this.cd.detectChanges());
  }

  hasVisibleItems(): boolean {
    const visibleLinks = this.getVisibleLinks();
    return visibleLinks.length > 0;
  }

  getVisibleLinks(): SidebarNavSectionLinkComponent[] {
    return this.links.filter(link => !link.hidden);
  }
}
